/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of authentication for OCI registries.
 */
export enum OciAuthType {
  DOCKER = 'docker',
}
